var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "card__content" },
          [
            _c("k-table", {
              ref: "bodegas",
              attrs: {
                path: _vm.path,
                columns: [
                  {
                    display: "Código",
                    value: "codigo"
                  },
                  {
                    display: "Cód. Sucursal",
                    value: "codigo_sucursal"
                  },
                  {
                    display: "Descripción",
                    value: "descripcion"
                  },
                  {
                    display: "Creador",
                    value: "creador.nombre"
                  },
                  {
                    display: "Creación",
                    value: "created_at"
                  },
                  {
                    display: "Modificador",
                    value: "modificador.nombre"
                  },
                  {
                    display: "Modificación",
                    value: "updated_at"
                  }
                ]
              },
              on: {
                crear: _vm.crear,
                editar: _vm.editar,
                eliminar: _vm.eliminar
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "bodega",
            scrollable: "",
            resizable: "",
            reset: "",
            adaptive: "",
            height: "auto",
            width: "60%"
          }
        },
        [
          _c("bodega", {
            ref: "bodega",
            on: { cancelar: _vm.cancelar, saved: _vm.savedBodega },
            model: {
              value: _vm.selectedBodega,
              callback: function($$v) {
                _vm.selectedBodega = $$v
              },
              expression: "selectedBodega"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Bodegas")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12dfb444", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12dfb444","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/inventario/Bodegas.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-12dfb444","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/inventario/Bodegas.vue
// module chunks = 0